
export enum SSEJobs {
    // Job Istantanei
    PRODUCTION_ON_DEMAND = "production-on-demand", // quando si materializzano le clip al volo (job istantaneo)
    // Job d'elaborazione
    INGESTION = 'ingestion',
    EXTRACTION = 'analysis',
    PRODUCTION = 'production',
}

export enum JobStatus {
    RUNNING = 'running',
    SCHEDULED = 'scheduled',
    STOPPED = 'stopped',
    FAILED = 'failed',
    COMPLETED = 'completed',
}

// LA FILTER BY NELLA PAGINA MONITOR CONTIENE PIÙ OGGETTI DEL TIPO FILTERJOB
export type filterJobs = { type : 'statusJob' | 'type' | 'match', value : string, op : 'eq' | 'gt' | 'lt'}

export enum GroupByFilters {
    TYPE = 'Agent Type',
    JOB_TYPE_AND_STATUS = 'Agent Type and Status',
    STATUS = 'Status'
}

export const STATUS_ORDER = ['Running', 'Started', 'Completed', 'Scheduled', 'Cancelled'];